import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import {
  brandonGrotesqueBold,
  brandonGrotesqueRegular
} from '../../styles/theme';

export const TypographyH1 = styled(Typography)(({ theme }) => ({
  fontSize: '1.25rem',
  lineHeight: '38pt',
  fontWeight: 400,
  wordBreak: 'break-word',
  color: theme?.palette?.common?.black,
  fontFamily: brandonGrotesqueBold,
  fontStyle: 'normal',
  textTransform: 'uppercase'
}));

export const TypographyH4 = styled(Typography)(() => ({
  color: '#002A3A',
  fontSize: '1.125rem',
  fontWeight: 450,
  fontFamily: brandonGrotesqueRegular,
  margin: '0.625rem'
}));

export const TypographyH3Bold = styled(Typography)(() => ({
  color: '#002A3A',
  fontSize: '1.5rem',
  fontWeight: 450,
  fontFamily: brandonGrotesqueBold
}));

export const TypographyH4White = styled(Typography)(() => ({
  color: '#FFF',
  fontSize: '1.125rem',
  fontWeight: 450,
  fontFamily: brandonGrotesqueRegular,
  margin: '0.625rem'
}));

export const TypographyH6 = styled(Typography)(() => ({
  color: '#002A3A',
  fontSize: '0.875rem',
  fontWeight: 450,
  fontFamily: brandonGrotesqueRegular
}));
